module.exports = __webpack_public_path__ + "static/media/congrats-tick.4a295dee.svg";